/**
 * Reducer for the main application tool bar.
 */
import * as constants from '../AppConstants';

const initialState = {
    isAuthenticated: undefined,
    onLogin: undefined,
    onLogout: undefined,
    dataClient: undefined
};

export const AppStateReducer = function(state = initialState, action) {
    switch(action.type) {
        case constants.SET_AUTHENTICATION_STATE: {
            return Object.assign({}, state, {
                isAuthenticated: action.isAuthenticated,
                onLogin: action.onLogin,
                onLogout: action.onLogout,
            });
        }

        case constants.INITIALIZE_APP:
            return Object.assign({}, state, {
                serverConfig: action.config
            });

        case constants.INIT_DATA_CLIENT:
            return Object.assign({}, state, { dataClient: action.dataClient });

        default:
            return state;
    }
}